export interface History {
  searchType: string;
  country: string;
  name: string;
  id: string;
  date: string;
  status: string;
  score: number;
  detail: string;
};

export interface BatchHistory {
  fileName: string;
  country: string;
  username: string;
  uploadDate: string;
  fileSize: number;
  progress: string;
  status: string;
  detail: string;
};

export interface ContinuousHistory {
  searchType: string;
  country: string;
  name: string;
  lastUpdated: string;
  nextUpdate: string;
  status: string;
  score: string;
  detail: string;
}

export interface Item {
  check: History[];
  batch: BatchHistory[];
  cck: ContinuousHistory[];
}

export interface Load {
  check: boolean;
  batch: boolean;
  cck: boolean;
}

export interface HistoryState {
  item: Item;
  load: Load;
}

export const defaultState: HistoryState = {
  item: {
    check: [],
    batch: [],
    cck: []
  },
  load: {
    check: true,
    batch: true,
    cck: true
  }
}

export default {
  ...defaultState
}
